import { useTranslation } from 'react-i18next'

type DifficultyLevel = 'easy' | 'moderate' | 'hard' | 'very_hard'

interface DifficultyIndicatorProps {
  difficulty: DifficultyLevel
}

const difficultyConfig: Record<DifficultyLevel, { key: string; color: string }> = {
  easy: { key: 'easy', color: '#84cc16' },
  moderate: { key: 'medium', color: '#f59e0b' },
  hard: { key: 'hard', color: '#ef4444' },
  very_hard: { key: 'very_hard', color: '#7c2d12' },
}

export const DifficultyIndicator = ({ difficulty }: DifficultyIndicatorProps) => {
  const { t } = useTranslation('pages')
  const config = difficultyConfig[difficulty] ?? difficultyConfig.moderate

  return (
    <div className="difficulty-indicator">
      <span className="difficulty-dot" style={{ background: config.color }} />
      <span className="difficulty-context-label">{t('common.difficulty.label')}</span>
      <span className="difficulty-label" style={{ color: config.color }}>
        {t(`common.difficulty.${config.key}`)}
      </span>
    </div>
  )
}
